import React, { Suspense, useState } from 'react';
import LazyLoad, { lazyload } from 'react-lazyload';
import { Lottie } from '@crello/react-lottie';

import Head from 'next/head';

import st from './index.module.scss';

import Pricing from '../../../components/video-production/Pricing';
import BradCrumbs from '../../../components/Base/BradCrumbs';
import Engagement from '../../../components/Engagement';
import Faq from '../../../components/Faq';
import ProcessSliderFrameByFrame from '../../../components/sliders/ProcessSliderFrameByFrame';
import typesLottie from '../../../public/images/types.json';
import Why from '../../../components/Why';
import ViewMore from '../../../components/ViewMore';
import BenefitsFrameByFrame from '../../../components/video-production/explainer-videos/BenefitsFrameByFrame';
import SolveProblemsFrameByFrame from '../../../components/video-production/explainer-videos/SolveProblemsFrameByFrame';

lazyload({
  width: '100%',
});

const ExplainerVideosFrameByFrame = props => {
  const [showPricingModalF, setShowPricingModalF] = useState(false);
  const [videoLength, setVideoLength] = useState([]);
  const [script, setScript] = useState([]);

  const showPricingModal = () => {
    if (props.width < 768) {
      window.location.href = '/video-production/get-pricing';
    } else {
      setShowPricingModalF(true);
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      window.location.hash = 'open';
    }
  };
  const hidePricingModal = () => {
    setShowPricingModalF(false);
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    history.replaceState(null, null, ' ');
    document.documentElement.style.overflow = 'auto';
  };

  return (
    <>
      <Head>
        <title>Video Production - Frame by Frame Explainer Video | Prodigi</title>
        <link rel="alternate" hrefLang="en" href="https://weprodigi.com/video-production/frame-by-frame-explainer-video" />
        <meta
          name="description"
          content="Discover the art of frame-by-frame explainer videos with Prodigi. Deliver your message through detailed and engaging animations."
        />
        <meta property="og:url" content="https://weprodigi.com/video-production/frame-by-frame-explainer-video" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Video Production - Frame by Frame Explainer Video | Prodigi" />
        <meta
          property="og:description"
          content="Discover the art of frame-by-frame explainer videos with Prodigi. Deliver your message through detailed and engaging animations."
        />
        <meta property="og:image" content="https://weprodigi.com/uploads/images/explainer-videos/frame-by-frame-explainer/og.jpg" />
        <script
          type="application/ld+json"
          className="organization-schema"
          dangerouslySetInnerHTML={{
            __html: `{
              "@context": "http://schema.org",
              "@type": "WebPage",
              "name": "Video Production - Frame by Frame Explainer Video | Prodigi",
              "description": "Discover the art of frame-by-frame explainer videos with Prodigi. Deliver your message through detailed and engaging animations.",
              "url": "https://weprodigi.com/video-production/frame-by-frame-explainer-video",
              "breadcrumb": {
                "@type": "BreadcrumbList",
                "itemListElement": [
                  {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Home",
                    "item": "https://weprodigi.com"
                  },
                  {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "Full Service Video Production",
                    "item": "https://weprodigi.com/video-production"
                  },
                  {
                    "@type": "ListItem",
                    "position": 3,
                    "name": "Frame by Frame Explainer Video Production",
                    "item": "https://weprodigi.com/video-production/frame-by-frame-explainer-video"
                  }
                ]
              },
              "mainEntity": {
                "@type": "Product",
                "name": "Frame by Frame Explainer Video Production",
                "description": "Discover the art of frame-by-frame explainer videos with Prodigi. Deliver your message through detailed and engaging animations.",
                "brand": {
                  "@type": "Brand",
                  "name": "Weprodigi"
                },
                "offers": {
                  "@type": "Offer",
                  "price": "13500",
                  "priceCurrency": "USD",
                  "seller": {
                    "@type": "Organization",
                    "name": "Weprodigi"
                  }
                },
                "image": "https://weprodigi.com/images/logovertical.svg",
                "review": [
                  {
                    "@type": "Review",
                    "reviewRating": {
                      "@type": "Rating",
                      "ratingValue": "5",
                      "bestRating": "5",
                      "worstRating": "1"
                    },
                    "author": {
                      "@type": "Person",
                      "name": "Emily Davis"
                    },
                    "datePublished": "2023-10-14",
                    "reviewBody": "I'm thrilled with the frame-by-frame explainer video created by this service. It brought my concept to life in a visually engaging way. Thank you Prodigi!"
                  },
                  {
                    "@type": "Review",
                    "reviewRating": {
                      "@type": "Rating",
                      "ratingValue": "5",
                      "bestRating": "5",
                      "worstRating": "1"
                    },
                    "author": {
                      "@type": "Person",
                      "name": "Sarah Paulson"
                    },
                    "datePublished": "2023-11-28",
                    "reviewBody": "Impressed with the frame-by-frame explainer video I received. It perfectly explained our product features. Will definitely use this service again!"
                  },
                  {
                    "@type": "Review",
                    "reviewRating": {
                      "@type": "Rating",
                      "ratingValue": "4.9",
                      "bestRating": "5",
                      "worstRating": "1"
                    },
                    "author": {
                      "@type": "Person",
                      "name": "David Miller"
                    },
                    "datePublished": "2024-03-9",
                    "reviewBody": "I needed a frame-by-frame explainer video on short notice, and this service delivered! Professional, efficient, and the final result was fantastic. Highly recommended!"
                  }
                ],
                "aggregateRating": {
                  "@type": "AggregateRating",
                  "ratingValue": "4.9",
                  "reviewCount": "3"
                }
              }
            }            
            `,
          }}
        />
      </Head>

      {/*    Header video */}
      <div className={`relative w-full  h-intro  overflow-hidden  `}>
        <video
          width="100%"
          height="100%"
          autoPlay
          loop
          muted
          playsInline
          preload="none"
          id="header-11"
          className={'absolute h-intro md:h-full ' + st['header-mp4']}
        >
          <source
            src="https://weprodigi.com/uploads/images/explainer-videos/frame-by-frame-explainer/frame-by-frame-explainer.mp4"
            type="video/mp4"
          />
        </video>
        <div className={st['overlay']}></div>
        <div className="container h-full">
          <div className="relative h-full  flex flex-col flex-wrap justify-center items-start overflow-hidden">
            <h1 className="max-w-300 md:max-w-600 uppercase md:normal-case text-white text-30 md:text-72 font-black md:font-bold leading-tight">
              Frame by Frame Animated Explainer Video Production
            </h1>
            <a
              onClick={showPricingModal}
              className="relative flex items-center justify-center min-w-250 z-10 border-2 rounded-5 border-green-badge hover:border-green-hover text-18 text-white px-23 mt-48 md:mt-23 py-8 bg-green-badge hover:bg-green-hover hover:text-white transition-all   transition-400 cursor-pointer"
            >
              Get Pricing
              <img src="https://weprodigi.com/uploads/images/explainer-videos/buttonIcon.svg" className={'ml-10'} alt="pricing icon" />
            </a>
          </div>
        </div>
      </div>

      <div className="bg-white">
        <div className="container">
          <BradCrumbs
            items={[
              {
                url: '/video-production',
                name: 'Video Production',
              },
              {
                url: '/video-production/explainer-videos',
                name: 'Explainer Video Production',
              },
              {
                url: '/video-production/frame-by-frame-explainer-video',
                name: 'Frame by Frame Video',
              },
            ]}
          />
          <div className="relative pt-20 md:pt-0 pb-48">
            <div className="flex flex-wrap md:flex-nowrap justify-between">
              <LazyLoad className="mr-auto mt-24 md:mt-0 max-w-270 w-full md:w-auto" height={200} once>
                <Lottie
                  config={{
                    animationData: typesLottie,
                    loop: true,
                    autoPlay: true,
                  }}
                  playingState="playing"
                />
              </LazyLoad>
              <div className="flex flex-col ml-12 items-center justify-center max-w-756">
                <Engagement title="Video">
                  Frame by frame animation is a unique gateway to the world of heartfelt visual storytelling. Each frame of hand-drawn animation can
                  touch the deepest corners of the human spirit. What is the secret behind this magical power? Let's discover together.
                </Engagement>
              </div>
            </div>
          </div>
        </div>
      </div>

      <LazyLoad height={200} once>
        <div className={'bg-gray-white py-24'}>
          <div className="container">
            <h2 className={'w-full  font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              What is frame by frame animated explainer video?
            </h2>

            <div className={'block md:flex justify-between flex-row md:flex-row-reverse'}>
              <div className=" pl-0 md:pl-20 pb-10 w-full md:w-half-auto block  mt-23 mb-10">
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/dyFmDTtUqZk?controls=0"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>B2C Project | Drawn Animation</p>
              </div>

              <p className={'mt-20 w-half-auto hidden md:block'}>
                Frame by frame animation is the most beloved form of animation. Famous cartoons like Mickey Mouse, Tom & Jerry, and SpongeBob
                SquarePants are created with this type of animation. It consists of hundreds, often even thousands of frames,which are drawn by hand
                and sequenced together to produce the illusion of movement. For each second in the cartoon, the animator creates 24 frames. Although
                today the frames are drawn digitally, the principle is fundamentally the same as in the good old days. Each frame of the animation is
                the result of meticulous handwork.
              </p>
              <div className={'mt-20 block md:hidden'}>
                <ViewMore ln={40}>
                  Frame by frame animation is the most beloved form of animation. Famous cartoons like Mickey Mouse, Tom & Jerry, and SpongeBob
                  SquarePants are created with this type of animation. It consists of hundreds, often even thousands of frames,which are drawn by hand
                  and sequenced together to produce the illusion of movement. For each second in the cartoon, the animator creates 24 frames. Although
                  today the frames are drawn digitally, the principle is fundamentally the same as in the good old days. Each frame of the animation
                  is the result of meticulous handwork.
                </ViewMore>
              </div>
            </div>
            <br className={'clear-both hidden'} />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-white py-24'}>
          <div className="container">
            <h2 className={'w-full md:w-75p font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              Where to Use Frame by Frame Explainer Videos?
            </h2>
            <p className={'mt-20'}>
              You watch an animated video frame by frame and relive warm childhood memories. It's a familiar feeling, isn't it? However,
              frame-by-frame animation isn't just a fun cartoon that evokes such nostalgic feelings. It is also a powerful tool that in different
              fields can serve different purposes.
            </p>

            <div className="flex flex-wrap-reverse md:flex-nowrap justify-between items-start mt-0 md:mt-24">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/jYWkmDOkZI4?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>B2B Project | Drawn Animation Explainer</p>
              </div>

              <div className={'w-full md:w-half-auto mt-24 md:mt-0'}>
                <h3 className="text-purple font-bold text-24   leading-none">Marketing and Advertising</h3>
                <div className={'mt-16 hidden md:block'}>
                  Searching for an impactful way to promote your product or service? Discover the power of frame-by-frame animated explainer video.
                  It's highly effective for social media ads, email campaigns, and website content. A hand-drawn explainer video is your first choice
                  if you want to connect with your customers on a deep emotional level, delivering your message in the most creative way.
                </div>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={40}>
                    Searching for an impactful way to promote your product or service? Discover the power of frame-by-frame animated explainer video.
                    It's highly effective for social media ads, email campaigns, and website content. A hand-drawn explainer video is your first
                    choice if you want to connect with your customers on a deep emotional level, delivering your message in the most creative way.
                  </ViewMore>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap md:flex-nowrap justify-between mt-0 md:mt-48">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <h3 className="text-purple font-bold text-24 leading-none">Education and Training</h3>
                <p className={'mt-16'}></p>

                <p className={'mt-16 hidden md:block'}>
                  Fun, eye-catching, and remarkable. That's frame by frame video animation in education and training. Tap into the warm breath of
                  childhood to simplify any idea. The cartoon style of hand-drawn animations nurtures an emotional bond with the viewers and enhances
                  learning. Use their power in classrooms, online courses, or training programs to boost engagement and retention.
                </p>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={40}>
                    Fun, eye-catching, and remarkable. That's frame by frame video animation in education and training. Tap into the warm breath of
                    childhood to simplify any idea. The cartoon style of hand-drawn animations nurtures an emotional bond with the viewers and
                    enhances learning. Use their power in classrooms, online courses, or training programs to boost engagement and retention.
                  </ViewMore>
                </div>
              </div>
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/ZF7XNWSFj_s?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>
                  B2B Project | Manufacturing Drawn Animation Explainer
                </p>
              </div>
            </div>
            <div className="flex flex-wrap-reverse md:flex-nowrap justify-between mt-24 md:mt-48">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/dyFmDTtUqZk?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>B2C Project | Drawn Animation</p>
              </div>

              <div className={'w-full md:w-half-auto '}>
                <h3 className="text-purple font-bold text-24 leading-none">Gaming and Entertainment</h3>
                <p className={'mt-16 hidden md:block'}>
                  Make your game app or software the main character of its own story. Use the unique charm of hand-drawn animations to create an
                  interactive explainer video. Whether it's a game launch, re-launch or just an update, it's a great tool to excite, inform and
                  educate your audience.
                </p>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={'40'}>
                    Make your game app or software the main character of its own story. Use the unique charm of hand-drawn animations to create an
                    interactive explainer video. Whether it's a game launch, re-launch or just an update, it's a great tool to excite, inform and
                    educate your audience.
                  </ViewMore>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-gray-light py-24'}>
          <div className="container">
            <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              Benefits of Frame by Frame Animated Videos
            </h2>
            <p className={'mt-20'}>
              Why choose frame-by-frame animation over other techniques for your explainer video? Here are some important benefits.
            </p>
            <Suspense fallback={`Loading...`}>
              <BenefitsFrameByFrame />
            </Suspense>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-white">
          <div className="container py-23">
            <h2 className="text-purple text-24 md:text-36 text-left mb-23 font-black uppercase leading-none">
              Our Frame by Frame Explainer Video Production Process
            </h2>
            <ProcessSliderFrameByFrame />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={0} once>
        <div className={'h-500 md:h-310 overflow-hidden relative ' + st['bg-contact']}>
          <div id="stars" />
          <div id="stars2" />
          <div id="stars3" />
          <div className="container flex flex-wrap md:flex-nowrap justify-between items-end md:items-center h-full ">
            <div className={'mt-24 md:mt-0 text-left md:text-center font-bold uppercase  text-white leading-28 md:leading-44   text-20 md:text-36'}>
              CALCULATE YOUR FRAME BY FRAME EXPLAINER VIDEO PRICE
              <br />
              <span className={'pt-20 font-normal normal-case text-18 md:text-24 leading-20 md:leading-29 '}>
                Answer five questions and get to know the price!
              </span>
              <div className={'flex justify-end md:justify-center mt-0 leading-0'}>
                <button
                  onClick={showPricingModal}
                  className="uppercase h-40 text-18 leading-24  hover:bg-green-hover md:flex justify-center items-center   w-auto mt-24 text-white bg-green rounded-5 px-23 py-0 md:py-5"
                >
                  Start Now
                </button>
              </div>
            </div>
            <img src="https://weprodigi.com/uploads/images/explainer-videos/Inga.webp" alt="eva" className={st['inga']} />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-white py-24'}>
          <div className="container">
            <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              How Frame by Frame Animated Explainer Video Can Help Your Business?
            </h2>
            <p className={'mt-20'}>
              Have you ever watched a classic Disney cartoon? Those that are full of miracles and glitter. And have you thought that their magic can
              also serve your business? Here's how.
            </p>
            <Suspense fallback={`Loading...`}>
              <SolveProblemsFrameByFrame />
            </Suspense>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-gray-light">
          <div className="container py-23">
            <h2 className="uppercase text-30 md:text-36 mb-23 font-black text-purple leading-none">
              Why Choose Us for Your Frame by Frame Explainer Video Production?
            </h2>
            <Why
              content={[
                {
                  title: 'We provide full frame-by-frame service',
                  answer:
                    'Our enthusiastic team of creative animators, illustrators and motion designers are ready to bring your brightest ideas to life with frame-by-frame video animation.',
                },
                {
                  title: 'We guarantee 100% customer satisfaction',
                  answer:
                    'Our animation and project management teams will communicate with you every step of the video production for your feedback. We will continue to improve your animation until you are 100% satisfied with the final version.',
                },
                {
                  title: 'We don’t require prepayment',
                  answer:
                    'We picked the milestone payment method for our hand-drawn illustration production services, as we believe that it is the best option for both us and our clients.',
                },
                {
                  title: 'We value your time',
                  answer:
                    'We know how precious your time is.Throughout the process of video production, we use proven methods to save your time as much as possible.',
                },
              ]}
            />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-white">
          <div className="container py-23">
            <h2 className="uppercase text-24 md:text-36 mb-23 font-black text-purple leading-none">FAQ</h2>
            <div className="grid md:grid-cols-2 md:gap-30">
              <Faq
                content={[
                  {
                    title: 'How does frame-by-frame animation differ from other animation styles?',
                    answer:
                      'Unlike other types, each frame of hand-drawn animation is prepared individually. One second of animation often requires 24 frames.',
                  },
                  {
                    title: 'How long does it take to produce a frame-by-frame animation?',
                    answer:
                      'Creating a frame-by-frame animation is meticulous work. A high-quality drawn animation of 60-90 seconds takes an average of 6-8 weeks.',
                  },
                ]}
              />
              <Faq
                content={[
                  {
                    title: 'Is frame-by-frame animation suitable for both short and long-form content?',
                    answer:
                      'Frame-by-frame animation is suitable for content of any length, from short commercials and social media ads to animated films, TV shows and educational videos.',
                  },
                  {
                    title: 'How much does frame-by-frame animated explainer video cost?',
                    answer:
                      'The average cost of a custom frame-by-frame animated explainer video, running from 45 seconds to 1 minute, starts at $13500.',
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </LazyLoad>

      <Pricing videoLength={videoLength} script={script} country={props.country} show={showPricingModalF} hide={hidePricingModal} step={1} />
    </>
  );
};

export default ExplainerVideosFrameByFrame;
